import { Currency } from '@pancakeswap/sdk'
import { LightCardProps } from '@/components/Card'

interface RangePriceSectionProps extends LightCardProps {
  title: string
  currency0?: Currency
  currency1?: Currency
  price: string
}

export const RangePriceSection = ({ title, currency0, currency1, price, ...props }: RangePriceSectionProps) => {
  return (
    <div className={'bg-secondary p-6 rounded-xl w-full flex flex-col gap-2 items-center'} {...props}>
      <div className={'text-sm'}>{title}</div>
      <h2 className={'text-2xl'}>{price}</h2>
      <div className={'text-sm text-gray-600'}>
        {currency0?.symbol} per {currency1?.symbol}
      </div>
    </div>
  )
}
